<template>
  <article
    v-click-outside="closeMenu"
    class="parking-complex-card"
    :class="{'parking-complex-card_expanded': expanded}"
    role="button"
    tabindex="0"
    :aria-expanded="String(expanded)"
    @click="$emit('toggle', complex)"
    @keydown.enter.prevent="$emit('toggle', complex)"
    @keydown.space.prevent="$emit('toggle', complex)"
  >
    <header class="parking-complex-card__header">
      <h3 class="parking-complex-card__title">
        {{ title }}
      </h3>
      <button
        class="parking-complex-card__menu"
        type="button"
        :aria-label="`Действия с комплексом ${title}`"
        :aria-expanded="String(isMenuOpen)"
        @click.stop="isMenuOpen = !isMenuOpen"
      >
        <span />
        <span />
        <span />
      </button>

      <div v-if="isMenuOpen" class="parking-complex-card__dropdown" @click.stop>
        <button type="button" @click="editComplex">
          Редактировать
        </button>
        <button type="button" class="is-danger" @click="deleteComplex">
          Удалить
        </button>
      </div>
    </header>
  </article>
</template>

<script>
/**
 * Карточка парковочного комплекса.
 */
export default {
  name: "ParkingComplexCard",
  props: {
    complex: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMenuOpen: false,
    };
  },
  computed: {
    title() {
      return this.complex.name || this.complex.title || "Без названия";
    },
  },
  methods: {
    closeMenu() {
      this.isMenuOpen = false;
    },
    editComplex() {
      this.closeMenu();
      this.$emit("edit", this.complex);
    },
    deleteComplex() {
      this.closeMenu();
      this.$emit("delete", this.complex);
    },
  },
};
</script>
